import { Link } from "react-router-dom";

export const Footer = () => (
  <footer className="bg-night text-paper/60" data-testid="site-footer">
    <div className="mx-auto max-w-6xl px-5 md:px-8 py-14 md:py-20">
      <p className="font-serif text-2xl text-paper" data-testid="footer-wordmark">
        Walk It Through
      </p>
      <p className="mt-6 max-w-xl text-sm leading-relaxed">
        Walk It Through does not provide legal, financial, medical, therapeutic
        or emergency advice or services. If you are in immediate danger or
        crisis, please contact the appropriate professional service promptly.
      </p>
      <nav className="mt-10 flex flex-wrap gap-x-8 gap-y-3 text-sm" aria-label="Legal">
        <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-paper transition-colors duration-300">
          Privacy Policy
        </Link>
        <Link to="/terms" data-testid="footer-terms-link" className="hover:text-paper transition-colors duration-300">
          Terms
        </Link>
        <Link to="/cancellation" data-testid="footer-cancellation-link" className="hover:text-paper transition-colors duration-300">
          Cancellation Policy
        </Link>
      </nav>
      <p className="mt-10 text-xs text-paper/35">
        © {new Date().getFullYear()} Walk It Through. Delivered by Luke.
      </p>
    </div>
  </footer>
);
